import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ui-organism-title-logos',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './ui-organism-title-logos.component.html',
  styleUrl: './ui-organism-title-logos.component.scss',
})
export class UiOrganismTitleLogosComponent {}
